import React from 'react';
import { styles } from './styles';

const Dropdown = ({ onSelect }) => {
    return (
      <div className="w-1/4 h-50 z-10 absolute right-0 top-full mt-2 p-2 w-40 bg-white hover:border-dashed hover:border-2 hover:border-purple-600 shadow-md rounded">
        <ul className='text-base font-semibold' style={styles.interCenter}>
          <li className="py-2 px-4 hover:bg-gray-300 hover:text-white  cursor-pointer" onClick={() => onSelect("Call Placed")}>Call Placed</li>
          <li className="py-2 px-4 hover:bg-blue-700 hover:text-white cursor-pointer" onClick={() => onSelect("Quotation Review")}>Quotation Review</li>
          <li className="py-2 px-4 hover:bg-yellow-300 hover:text-white cursor-pointer" onClick={() => onSelect("Job In Progress")}>Job In Progress</li>
          <li className="py-2 px-4 hover:bg-green-500 hover:text-white cursor-pointer" onClick={() => onSelect("Completed")}>Completed</li>
        </ul>
      </div>
    );
  };
export default Dropdown
